import React from 'react';
import moment from 'moment';
import MenigoCalendar from 'Shared/DeliveryDates/Calendar';
import { DateObject } from 'react-multi-date-picker';
export const DATE_FORMAT = 'YYYY-MM-DD';
export default class DeliveryDateSelection extends React.Component {
    constructor(props) {
        super(props);
        this.isOutsideRange = (day) => {
            return !this.isInRange(day) || this.isBeforeAvailabilityDate(day);
        };
        this.isBeforeAvailabilityDate = (day) => {
            const availabilityDate = this.props.availability;
            return availabilityDate && day.isBefore(moment(availabilityDate.availabilityDate, DATE_FORMAT), 'day');
        };
        this.isInRange = (day) => {
            return (this.props.deliveryDays || []).some(d => day.format(DATE_FORMAT) === d.date);
        };
        this.onDateChange = (day) => {
            this.setState({ selectedDay: day });
            if ((this.isInRange(day) && !day.isBefore(moment())) ||
                moment(day).format(DATE_FORMAT) ===
                    moment()
                        .add(1, 'days')
                        .format(DATE_FORMAT)) {
                this.props.onDateSelected(day, true);
            }
        };
        this.onFocusChange = (arg) => {
            this.setState({ focused: arg.focused });
        };
        this.state = {
            focused: true,
            selectedDay: this.getSelectedDayFromProps(),
        };
    }
    getSelectedDayFromProps() {
        if (this.props.selectedDay) {
            return this.props.selectedDay;
        }
        else if (this.props.deliveryDays && this.props.deliveryDays.length > 0) {
            return moment(this.props.deliveryDays[0].date);
        }
        return null;
    }
    render() {
        return (React.createElement(MenigoCalendar, { value: this.state.selectedDay
                ? new DateObject(this.state.selectedDay.format(DATE_FORMAT))
                : null, mapDays: ({ date }) => {
                const isNotAllowed = this.isOutsideRange(moment(date.toString()));
                return {
                    disabled: isNotAllowed,
                    style: isNotAllowed
                        ? { color: "#cacccd", borderRadius: '0px', border: 'none' }
                        : {},
                };
            }, onFocusedDateChange: (date, clickedDate) => { this.onDateChange(moment(clickedDate.toString())); } }));
    }
}
